// Add your JS customizations here
jQuery(document).ready(function($) {
	// Add your custom jQuery here
	// nospam
	jQuery('.nospam').each(function(){
		var email = jQuery(this).html();
		email = email.replace("[arobase]","@");
		email = email.replace("[point]",".");
		var data = email;
		if(jQuery(this).attr("title") && jQuery(this).attr("title")!="") { data = jQuery(this).attr("title"); }
		jQuery(this).html("<a href=\"mailto:"+email+"\">"+data+"</a>");
	});
// Menu fixe au scroll V2
	jQuery(window).scroll(function (event) {
		let y = jQuery(this).scrollTop(); // On récupérer la valeur du scroll vertical
		const anchor = document.getElementById("main-nav").scrollHeight; // on defini l'élément qui va servir de référence pour la hauteur du scroll, attention il faut mettre une hauteur à cet élément dans le css
		console.log(document.getElementById("main-nav").scrollHeight);
		if ( y >= (anchor*1.2)) {
			jQuery('.nav-principal').addClass('menu-fixe');
		} else {
			jQuery('.nav-principal').removeClass('menu-fixe');
		}
		/*pour le bouton de retour en haut de page*/
		let z = jQuery(this).scrollTop();
		if ( z >= (window.innerHeight/2) ) {
			jQuery('#myBtnUp').addClass('d-block');
			jQuery('#myBtnUp').removeClass('d-none');
		} else {
			jQuery('#myBtnUp').removeClass('d-block');
			jQuery('#myBtnUp').addClass('d-none');
		}

	}) ;
	add_filter('get_the_archive_title', function ($title) {
		if (is_category()) {
			$title = single_cat_title('', false);
		}
		return $title;
	});


});



gsap.registerPlugin(ScrollTrigger);

gsap.utils.toArray(".content-block").forEach(block => {
	// console.log("Animation appliquée à :", block); // ← vérifie dans la console

	gsap.fromTo(block,
		{
			opacity: 0,
			scale: 0.95,
		},
		{
			opacity: 1,
			scale: 1,
			ease: "power1.out",
			scrollTrigger: {
				trigger: block,
				start: "top 85%",
				end: "top 30%",
				scrub: true,
				onEnter: () => block.classList.add("debug-visible"),
			}
		}
	);
});


